import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useDocumentTypesList() {

    //User toast
    const toast = useToast()

    const refDocumentTypeListTable = ref(null)

    const tableColumns = [
        {key: 'name', label:'文件名稱',sortable: true},
        {key: 'description', label: '描述'},
        {key: 'actions', label: '操作'},
    ]

    const perPage = ref(10)
    const totalDocumentTypes = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refDocumentTypeListTable.value ? refDocumentTypeListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalDocumentTypes.value,
        }
    })

    const refetchData = () => {
        refDocumentTypeListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchDocumentTypes = (ctx, callback) => {
        store.dispatch('setting-documenttype/fetchDocumentTypes',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {document_types, total} = response.data
            callback(document_types)
            totalDocumentTypes.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching project stages list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchDocumentTypes,
        tableColumns,
        perPage,
        currentPage,
        totalDocumentTypes,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refDocumentTypeListTable,
        ability,
        refetchData
    }

}